import { render, staticRenderFns } from "./GeoDetails.vue?vue&type=template&id=10c55026&scoped=true&"
import script from "./GeoDetails.vue?vue&type=script&lang=js&"
export * from "./GeoDetails.vue?vue&type=script&lang=js&"
import style0 from "./GeoDetails.vue?vue&type=style&index=0&id=10c55026&prod&lang=scss&"
import style1 from "./GeoDetails.vue?vue&type=style&index=1&id=10c55026&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c55026",
  null
  
)

export default component.exports